export function merchantName(item: { agent_id?: number | null; agent_name?: string | null }, fallback = '—'): string {
  const name = item.agent_name?.trim();
  if (name) return item.agent_id ? `${name}（#${item.agent_id}）` : name;
  return item.agent_id ? `商户 #${item.agent_id}` : fallback;
}
